// extracted by mini-css-extract-plugin
module.exports = {"cookieModal":"CookiesTab_cookieModal__1kHPi"};